export const getElementOffset = (
  el: HTMLElement,
  side: 'top' | 'bottom' = 'top',
) => {
  return Number(
    (
      el.getBoundingClientRect()[side] + document.documentElement.scrollTop
    ).toFixed(0),
  );
};
